import { Container, Section, Eyebrow, Reveal } from "@/components/kit";

const steps = [
  {
    n: "01",
    title: "Discovery & ICP definition",
    desc: "We map your ideal customer profile, offer, and the exact parameters that define a qualified meeting.",
  },
  {
    n: "02",
    title: "Research & list building",
    desc: "Accounts are scored, contacts enriched, and buying signals layered on top of your TAM.",
  },
  {
    n: "03",
    title: "Messaging & infrastructure",
    desc: "We build warmed sending infrastructure and craft tested, research-backed messaging angles.",
  },
  {
    n: "04",
    title: "Multi-channel launch",
    desc: "Orchestrated email, LinkedIn and calling sequences go live and are optimized in real time.",
  },
  {
    n: "05",
    title: "Qualification & booking",
    desc: "Interested prospects are vetted against your parameters, then booked to your calendar.",
  },
  {
    n: "06",
    title: "Report, optimize, scale",
    desc: "Transparent reporting on qualified meetings — we double down on what converts and cut what doesn't.",
  },
];

export const Process = () => (
  <Section data-testid="process-section">
    <Container>
      <div className="max-w-3xl">
        <Eyebrow>The Process</Eyebrow>
        <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white">
          From kickoff to qualified pipeline
        </h2>
      </div>

      <div className="mt-14 grid gap-x-8 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={(i % 3) * 0.08}>
            <div className="group relative">
              <span className="pointer-events-none block font-mono-jb text-6xl md:text-7xl font-semibold leading-none text-white/[0.07] transition-colors duration-300 group-hover:text-gold/20">
                {s.n}
              </span>
              <div className="mt-4 h-px w-12 bg-gold/40 transition-all duration-300 group-hover:w-20" />
              <h3 className="mt-5 font-display text-xl font-semibold text-white">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Container>
  </Section>
);
